import { Formik, Form } from 'formik';
import { Box, Flex, Text } from '@applatform/design-system';
import Alert from 'components/V1/Alert/Alert';
import Link from 'components/V1/Link/Link';
import AuthCard from 'components/V2/Auth/AuthCard';
import AuthField from 'components/V2/Auth/AuthField';
import AuthButton from 'components/V2/Auth/AuthButton';
import { v2Colors } from 'theme';
import EnvironmentSegmentV2 from './EnvironmentSegmentV2/EnvironmentSegmentV2';
import useLoginForm from './useLoginForm';

function LoginV2() {
  const {
    initialValues,
    validationSchema,
    handleSubmit,
    error,
    isSubmitting,
    passwordChanged,
    Track,
  } = useLoginForm();

  return (
    <Track>
      <AuthCard title="Sign in">
        {passwordChanged && (
          <Alert status="success" css={{ mb: '$4' }}>
            Your password has been changed
          </Alert>
        )}
        <EnvironmentSegmentV2 />
        <Formik
          initialValues={initialValues}
          onSubmit={handleSubmit}
          validationSchema={validationSchema}
        >
          {({ errors, touched, values, handleChange, handleBlur }) => (
            <Form>
              {error && (
                <Alert status="error" css={{ mb: '$4' }}>
                  {error}
                </Alert>
              )}
              <AuthField
                id="email"
                name="email"
                label="Email"
                type="email"
                value={values.email}
                onChange={handleChange}
                onBlur={handleBlur}
                error={touched.email ? errors.email : undefined}
              />
              <AuthField
                id="password"
                name="password"
                label="Password"
                type="password"
                value={values.password}
                onChange={handleChange}
                onBlur={handleBlur}
                error={touched.password ? errors.password : undefined}
              />
              <Flex
                css={{ justifyContent: 'flex-end', mb: '$5', fontSize: '13px' }}
              >
                <Link to="/reset-password">Forgot password?</Link>
              </Flex>
              <AuthButton type="submit" isLoading={isSubmitting}>
                Continue{' '}
                <Box as="span" aria-hidden="true" css={{ ml: '$2' }}>
                  →
                </Box>
              </AuthButton>
            </Form>
          )}
        </Formik>
        <Alert
          role="note"
          css={{
            mt: '$6',
            p: '$3',
            fontSize: '12px',
            lineHeight: 1.45,
            color: v2Colors.muted,
            backgroundColor: v2Colors.plane,
            border: `1px solid ${v2Colors.line}`,
            borderRadius: '$md',
          }}
        >
          {/* `Text` sets its own font-weight, so a bare <b> renders at 400. */}
          <Text as="b" css={{ fontWeight: '$bold', color: v2Colors.ink2 }}>
            Multi-factor authentication required.
          </Text>{' '}
          After submitting your password you may be asked for a code from your
          authenticator app. Live and Pre-live use separate credentials.
        </Alert>
      </AuthCard>
    </Track>
  );
}

export default LoginV2;
